import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { FeatureFlags } from '@repo/wemod-api/features/schema';
import { fetchFeatureFlagsClientSide } from '@repo/wemod-api-client/features-api/client';

export interface FeatureFlagsState {
    flags: FeatureFlags | null;
}

const initialState: FeatureFlagsState = {
    flags: null,
};

export const refreshFeatureFlags = createAsyncThunk('featureFlags/refresh', async (bearerToken?: string | null) =>
    fetchFeatureFlagsClientSide({ bearerToken }),
);

const featureFlagsSlice = createSlice({
    name: 'featureFlags',
    initialState,
    reducers: {
        setFeatureFlags: (state, action: PayloadAction<FeatureFlags>) => {
            state.flags = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(refreshFeatureFlags.fulfilled, (state, action) => {
            state.flags = action.payload;
        });
    },
});

export const { setFeatureFlags } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;

export const selectFeatureFlags = (state: { featureFlags: FeatureFlagsState }): FeatureFlags | null =>
    state.featureFlags.flags;

export const selectFeatureFlag =
    <K extends keyof FeatureFlags>(key: K) =>
    (state: { featureFlags: FeatureFlagsState }): FeatureFlags[K] | undefined =>
        state.featureFlags.flags?.[key];
